<template>
  <div class="wishlist-badge" :class="{ active: favourite }">
      <button @click.prevent="toggleFavourite">
          <img src="/img/icons/wishlist-2.svg"
               alt="Pridať medzi obľúbené"
               v-svg-inline
          />
      </button>
  </div>
</template>

<script>
import { inject, reactive, toRefs, onMounted } from 'vue'
import axios from 'axios'
import {getFromCategoriesBy} from "../../functions/helpers";

export default {

  props: [
      'productId',
      'withModal',
      'btnText',
      'onDetail',
      'favouriteProp',
      'gtmDataP',
      'dataRoute',
      'dataRouteRemove'
  ],

  setup(props) {

    const state = reactive({
      showModal: false,
      productId: props.productId,
      favourite: props.favouriteProp,
        gtmData: JSON.parse(props.gtmDataP),
    })

    const emitter = inject('emitter')

    function toggleFavourite() {
      state.favourite ? remove() : add()
    }

    function add() {
        axios.get(props.dataRoute)
            .then( (response) => {
                if ( response.status === 200 ) {
                    state.favourite = true
                    flash(response.data.message, response.data.type)
                    // update header heart icon count
                    updateFavouritesCount(response.data.count)
                    emitEvent()
                }
            }).catch((error) => console.error(error))
    }

    function remove() {

        axios.get(props.dataRouteRemove)
            .then((response) => {
                if ( response.status === 200 ) {
                    state.favourite = false
                    emitter.emit('on-product-deleted', props.productId)
                    emitter.emit('product-wishlist-update', response.data.message)
                    flash(response.data.message, response.data.type)
                    //update header heart icon count
                    updateFavouritesCount(response.data.count)
                }
            }).catch((error) => console.log(error))
    }

      function updateFavouritesCount(count) {
            const icon = document.getElementById('wishlistItemCounter')

            if (count == 0 || count == undefined || count == null || count == "")
                count = 0
            icon.textContent = count
            emitter.emit('on-wishlist-count-change', count)
        }

      const emitEvent = () => {
          emitter.emit('track-event', {
              data: state.gtmData,
              event: 'addToWishlist'
          })
      }

    return {
      ...toRefs(state),
      add,
      remove,
      toggleFavourite
    }
  }
}
</script>
